import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import { RHFAutocomplete, RHFTextField } from 'src/components/hook-form';
import { TextField, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';

export default function EmpImpqueNewEditForm({ impQueArr }) {
  const yesNoArr = ['Yes', 'No'];
  const { control, setValue, watch, resetField, register } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'impQuesC',
  });
  return (
    <>
      <Box mt={4}>
        {/* <Typography variant="subtitle2" sx={{ mb: 3 }}>
          Important Questionnaire:
        </Typography> */}
        <Box mt={2}>
          <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
            Important Questionaire:
          </Typography>
        </Box>
        {fields.map((item, index) => (
          <Stack key={item.id} spacing={1.5}>
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
              <RHFTextField name={`impQuesC[${index}].iqSrno`} />
            </Box>
            <Stack direction="row" flexWrap="wrap" alignItems="center" spacing={1.5}>
              {/* <Typography variant="body2">{index + 1}. </Typography> */}
              <RHFAutocomplete
                name={`impQuesC[${index}].impQue`}
                options={impQueArr || []}
                disableClearable
                getOptionLabel={(option) => {
                  if (!option) return '';
                  if (typeof option === 'object') {
                    const qText = option.question || option.masterName || option.questionName || (option.questionId && (option.questionId.question || option.questionId.masterName));
                    if (qText) return `${index + 1}) ${qText}`;
                    const optId = option.id || option.masterId || option.impQueId || (option.questionId && (option.questionId.id || option.questionId.masterId));
                    const found = impQueArr?.find((q) => (q.id || q.masterId) === optId);
                    if (found) return `${index + 1}) ${found.question || found.masterName}`;
                    return '';
                  }
                  if (typeof option === 'number' || typeof option === 'string') {
                    const found = impQueArr?.find((q) => (q.id || q.masterId) === Number(option));
                    return found ? `${index + 1}) ${found.question || found.masterName}` : String(option);
                  }
                  return '';
                }}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  const optId = typeof option === 'object' ? (option.id || option.masterId || option.impQueId || (option.questionId && (option.questionId.id || option.questionId.masterId))) : option;
                  const valId = typeof value === 'object' ? (value.id || value.masterId || value.impQueId || (value.questionId && (value.questionId.id || value.questionId.masterId))) : value;
                  return optId === valId;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    multiline
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      readOnly: true,  // Optional: Set to `true` to prevent editing
                    }}
                    sx={{
                      wordWrap: 'break-word',  // Ensure long questions wrap correctly
                      whiteSpace: 'normal',    // Allows text to break and be visible
                      overflowWrap: 'break-word', // Ensures word breaks to avoid overflow
                      '.MuiOutlinedInput-root': {
                        '& fieldset': {
                          border: 'none',
                        },
                      }
                    }}
                  />
                )}
                sx={{
                  width: '85%',
                  pointerEvents: 'none', // Disables user interaction
                  '.MuiAutocomplete-endAdornment': {
                    display: 'none', // Hides the dropdown icon
                  },
                }}
              />
              <RHFAutocomplete
                sx={{
                  width: '12%',
                  minWidth: 100,
                  '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
                    padding: '7.5px 28px 6.5px 4px !important', // Add specific PADDING for the Autocomplete input 
                  }
                }}
                name={`impQuesC[${index}].ans`}
                options={yesNoArr}
                getOptionLabel={(option) => (typeof option === 'object' ? option.label || option.value : option) || ""}
                isOptionEqualToValue={(option, value) => {
                  const opt = typeof option === 'object' ? option.value || option.label : option;
                  const val = typeof value === 'object' ? value.value || value.label : value;
                  return opt === val;
                }}
                disableClearable
              />
              <RHFTextField
                name={`impQuesC[${index}].ansComment`}
                placeholder="Add Comment..."
                multiline
                rows={2}
                sx={{ mb: '10px' }}
              />
            </Stack>
          </Stack>
        ))}
      </Box>
    </>
  );
}
EmpImpqueNewEditForm.propTypes = {
  impQueArr: PropTypes.array,
};
